// @ts-nocheck
import React from 'react';
import { stouApi } from '../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
import styled from 'styled-components';
const OptionContent = styled.span.withConfig({
  displayName: "StouSelect__OptionContent",
  componentId: "sc-tgfm3c-0"
})(["display:flex;justify-content:space-between;align-items:center;"]);
const OptionName = styled.span.withConfig({
  displayName: "StouSelect__OptionName",
  componentId: "sc-tgfm3c-1"
})(["white-space:nowrap;max-width:80%;text-overflow:ellipsis;overflow:hidden;"]);
export default ({
  filter = {},
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  return await stouApi.fetchStouList({
    ...filter,
    ...params
  });
}} placeholder="Выберите запись СТОУ" refetchParams={{
  filter
}} fetchSingle={stouApi.fetchStouList} notFoundText="Элементы СТОУ не найдены" renderOption={(stou, Option) => <Option key={stou.id} value={stou.mnemonic} stou={stou}>
        <OptionContent>
          <OptionName>{stou.mnemonic}</OptionName>
        </OptionContent>
      </Option>} {...selectProps} />;
